export default {
  init() {
    // JavaScript to be fired on all pages
    window.addEventListener('scroll', globalSticky)
    megaMenu()
    setHeaderHeightVariable()
    openAnchor()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}

const globalSticky = () => {
  const { scrollY } = window

  if (scrollY > 100) {
    document.body.classList.add('is-sticky')
  } else {
    document.body.classList.remove('is-sticky')
  }
}

const megaMenu = () => {
  const MENU_ACTIVE_CLASS = 'open-menu'
  const menuToggle = document.getElementById('menu-nav-toggle')
  const overlayToggle = document.getElementById('menu-overlay-toggle')
  const closeToggle = document.getElementById('menu-close-toggle')
  const menu = document.getElementById('menu-megamenu')

  const toggleMenu = () => {
    console.log(`toggleMenu`) //eslint-disable-line
    if (menu.classList.contains(MENU_ACTIVE_CLASS)) {
      menu.classList.remove(MENU_ACTIVE_CLASS)
      overlayToggle.classList.remove(MENU_ACTIVE_CLASS)
    } else {
      menu.classList.add(MENU_ACTIVE_CLASS)
      overlayToggle.classList.add(MENU_ACTIVE_CLASS)
    }
  }

  menuToggle.addEventListener('click', toggleMenu)
  overlayToggle.addEventListener('click', toggleMenu)
  closeToggle.addEventListener('click', toggleMenu)
}

const setHeaderHeightVariable = () => {
  const setHeight = (variable = '--header-height') => {
    const height = document.querySelector('header.dhsv-header').clientHeight

    document.documentElement.style.setProperty(variable, height + 'px')
  }

  setHeight('--init-header-height')
  document.addEventListener('resize', () => {
    if (window.scrollY === 0) {
      setHeight('--init-header-height')
    }
  })

  setHeight()

  document.addEventListener('resize', setHeight)
  document.addEventListener('scroll', setHeight)
}

const openAnchor = () => {
  const toggleBtn = document.getElementById('select-anchor')
  const menu = document.getElementById('anchor-nav')
  const closeMenu = document.getElementById('close-anchor-menu')
  const body = document.querySelector('body')
  const items = document.querySelectorAll(
    '.menu-content > .dhsv-anchor-block > p > a'
  )

  const toggleMenu = () => {
    menu.classList.toggle('active')
    body.classList.toggle('no-scroll')
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', toggleMenu)
  }

  if (closeMenu) {
    closeMenu.addEventListener('click', toggleMenu)
  }

  if (items) {
    items.forEach(item => {
      item.addEventListener('click', toggleMenu)
    })
  }
}
